(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1118],{

/***/ 2770:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* reexport */ CalendarPage; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js + 5 modules
var toConsumableArray = __webpack_require__(76687);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(32125);
// EXTERNAL MODULE: ./src/components/elements/SectionTitle/index.tsx
var SectionTitle = __webpack_require__(70770);
// EXTERNAL MODULE: ./src/components/elements/Spacer/index.tsx
var Spacer = __webpack_require__(1253);
// EXTERNAL MODULE: ./src/components/layout.tsx + 7 modules
var layout = __webpack_require__(55548);
// EXTERNAL MODULE: ./src/components/layouts/Head/index.tsx
var Head = __webpack_require__(22978);
// EXTERNAL MODULE: ./src/components/layouts/Ir/index.tsx
var Ir = __webpack_require__(87661);
// EXTERNAL MODULE: ./src/components/layouts/Ir/Heading.tsx
var Heading = __webpack_require__(82592);
// EXTERNAL MODULE: ./src/components/layouts/Ir/Mpocket/Accordion.tsx
var Accordion = __webpack_require__(21499);
// EXTERNAL MODULE: ./src/hooks/useMpocketScript.ts
var useMpocketScript = __webpack_require__(98259);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/pages/Ir/Calendar/index.tsx



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }














var CalendarPage = function CalendarPage(_ref) {
  var items = _ref.items;
  (0,useMpocketScript/* useMpocketScript */.k)('//irpocket.com/141A/irpocket/config-utils-main.js'); // useMpocketScript('//irpocket.com/5882/irpocket/config-utils-main.js')

  var groupByItemName = function groupByItemName(data) {
    var sortedData = (0,toConsumableArray/* default */.Z)(data).sort(function (a, b) {
      return new Date(b.published).getTime() - new Date(a.published).getTime();
    });

    var grouped = sortedData.reduce(function (acc, item) {
      if (!acc[item.itemName]) {
        acc[item.itemName] = {
          itemName: item.itemName,
          itemName_en: item.itemName_en,
          items: []
        };
      }

      acc[item.itemName].items.push(item);
      return acc;
    }, {});
    return Object.values(grouped);
  };

  var groupedData = groupByItemName(items);

  var _useState = (0,react.useState)(function () {
    var initialState = {};

    if (groupedData.length > 0) {
      initialState[0] = true;
    }

    return initialState;
  }),
      openStates = _useState[0],
      setOpenStates = _useState[1];

  var toggleOpen = function toggleOpen(index) {
    setOpenStates(function (prev) {
      return _objectSpread(_objectSpread({}, prev), {}, (0,defineProperty/* default */.Z)({}, index, !prev[index]));
    });
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Ir/* Layout */.A, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SectionTitle/* SectionTitle */.N, {
      color: "normal",
      titleText: "IR Calendar",
      subTitleText: "IR\u30AB\u30EC\u30F3\u30C0\u30FC"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
      h: {
        sp: 70,
        pc: 120
      }
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("section", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Heading/* AHeading */.Os, {
        children: "IR\u30AB\u30EC\u30F3\u30C0\u30FC"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("picture", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("source", {
          media: "(max-width: 1047px)",
          srcSet: "/images/IRCalendarSP.webp",
          width: "335",
          height: "433"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Image, {
          src: "/images/IRCalendarPC.webp",
          alt: "IR\u30AB\u30EC\u30F3\u30C0\u30FC",
          width: "1040",
          height: "300"
        })]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
      h: {
        sp: 50,
        pc: 80
      }
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Accordion/* Accordion */.U, {
      children: groupedData.map(function (item, index) {
        var isOpen = openStates[index] || false;
        return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            onClick: function onClick() {
              return toggleOpen(index);
            },
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              className: isOpen ? 'iZwYFc' : ''
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
              children: item.itemName
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {}), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: isOpen ? '' : 'bkpqNp',
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
              children: item.items.map(function (a, b) {
                return /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)("time", {
                    children: formatDate(a.published)
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                      children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                        href: a.link,
                        target: a.target,
                        children: a.title
                      })
                    })
                  })]
                }, b);
              })
            })
          })]
        }, item.itemName);
      })
    })]
  });
};

var formatDate = function formatDate(date) {
  return new Date(date).toLocaleDateString("zh-CN", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit"
  }).replace(/\//g, "/");
};

CalendarPage.getLayout = function (page) {
  var breadCrumbs = [{
    name: 'ホーム',
    path: '/'
  }, {
    name: '株主・投資家向け情報',
    path: '/ir'
  }, {
    name: 'IRカレンダー',
    path: ''
  }];
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Head/* Head */.F, {
      title: "IR\u30AB\u30EC\u30F3\u30C0\u30FC",
      description: " \u30C8\u30E9\u30A4\u30A2\u30EB\u30DB\u30FC\u30EB\u30C7\u30A3\u30F3\u30B0\u30B9\u306EIR\u306B\u95A2\u3059\u308B\u30B9\u30B1\u30B8\u30E5\u30FC\u30EB\u3092\u63B2\u8F09\u3057\u3066\u3044\u307E\u3059\u3002",
      ogp: {
        url: 'ir/calendar/'
      }
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(layout/* TitleLayout */.$0, {
      title: "Investor Relations",
      subTitle: "\u682A\u4E3B\u30FB\u6295\u8CC7\u5BB6\u5411\u3051\u60C5\u5831",
      breadCrumbs: breadCrumbs,
      children: page
    })]
  });
};

var Image = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
  displayName: "Calendar__Image",
  componentId: "sc-1t1wmrq-0"
})(["width:100%;height:100%;"]);
;// CONCATENATED MODULE: ./src/pages/ir/calendar/index.tsx
var __N_SSG = true;


/***/ }),

/***/ 71550:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ir/calendar",
      function () {
        return __webpack_require__(2770);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1228,3874,9181,5548,2623,9774,2888,179], function() { return __webpack_exec__(71550); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);